var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "afil-network" } }, [
    _c("img", { ref: "af-network-img", attrs: { id: "af-network-img" } }),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showTableList == false,
            expression: "showTableList == false",
          },
        ],
        attrs: { id: "af-wrap" },
      },
      [_c("div", { attrs: { id: "af" } })]
    ),
    _vm._v(" "),
    _c("div", { attrs: { id: "afil-legend" } }, [
      _c("ul", [
        _c("li", { ref: "edge.UPR" }, [
          !_vm.legend.edge.UPR
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("div", [_vm._v("Руководитель, Упр. компания")]),
        ]),
        _vm._v(" "),
        _c("li", { ref: "edge.UPR_HISTORY" }, [
          !_vm.legend.edge.UPR_HISTORY
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("div", [_vm._v("Бывший руководитель")]),
        ]),
        _vm._v(" "),
        _c("li", { ref: "edge.UCHR" }, [
          !_vm.legend.edge.UCHR
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c("div", [_vm._v("Учредитель")]),
        ]),
        _vm._v(" "),
        _c("li", { ref: "edge.UCHR_HISTORY" }, [
          !_vm.legend.edge.UCHR_HISTORY
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _c("div", [_vm._v("Бывший учредитель")]),
        ]),
        _vm._v(" "),
        _c("li", { ref: "edge.REGISTRY_HOLDER" }, [
          !_vm.legend.edge.REGISTRY_HOLDER
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _vm._m(4),
          _vm._v(" "),
          _c("div", [_vm._v("Реестродержатель")]),
        ]),
        _vm._v(" "),
        _c("li", { ref: "edge.PREDSH" }, [
          !_vm.legend.edge.PREDSH
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _vm._m(5),
          _vm._v(" "),
          _c("div", [_vm._v("Предшественник")]),
        ]),
        _vm._v(" "),
        _c("li", { ref: "edge.PREEM" }, [
          !_vm.legend.edge.PREEM
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _vm._m(6),
          _vm._v(" "),
          _c("div", [_vm._v("Преемник")]),
        ]),
        _vm._v(" "),
        _c("li", { ref: "edge.RODSTV" }, [
          !_vm.legend.edge.RODSTV
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _vm._m(7),
          _vm._v(" "),
          _c("div", [_vm._v("Родственник")]),
        ]),
        _vm._v(" "),
        _c("li", { ref: "edge.STAFF" }, [
          !_vm.legend.edge.STAFF
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _vm._m(8),
          _vm._v(" "),
          _c("div", [_vm._v("Сотрудник")]),
        ]),
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", { ref: "node.ULRos" }, [
          !_vm.legend.node.ULRos
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _c("i", { staticClass: "fa fa-building" }),
          _vm._v("\n                Юридическое лицо\n            "),
        ]),
        _vm._v(" "),
        _c("li", { ref: "node.ULIn" }, [
          !_vm.legend.node.ULIn
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _c("i", { staticClass: "fa fa-globe" }),
          _vm._v(
            "\n                Иностранное юридическое лицо\n            "
          ),
        ]),
        _vm._v(" "),
        _c("li", { ref: "node.FL" }, [
          !_vm.legend.node.FL
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _c("i", { staticClass: "fa fa-male" }),
          _vm._v("\n                Физическое лицо\n            "),
        ]),
        _vm._v(" "),
        _c("li", { ref: "node.IP" }, [
          !_vm.legend.node.IP
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _c("i", { staticClass: "fa fa-user" }),
          _vm._v(
            "\n                Индивидуальный предприниматель\n            "
          ),
        ]),
        _vm._v(" "),
        _c("li", { ref: "node.PIF" }, [
          !_vm.legend.node.PIF
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _c("i", { staticClass: "fa fa-university" }),
          _vm._v("\n                Субъект РФ, ПИФ\n            "),
        ]),
        _vm._v(" "),
        _c("li", { ref: "status.green" }, [
          !_vm.legend.status.green
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "status-color-block status-color-block__green",
          }),
          _vm._v("\n                Действущее\n            "),
        ]),
        _vm._v(" "),
        _c("li", { ref: "status.orange" }, [
          !_vm.legend.status.orange
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "status-color-block status-color-block__orange",
          }),
          _vm._v("\n                В стадии ликвидации\n            "),
        ]),
        _vm._v(" "),
        _c("li", { ref: "status.red" }, [
          !_vm.legend.status.red
            ? _c("div", { staticClass: "legend__line-through" })
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "status-color-block status-color-block__red",
          }),
          _vm._v("\n                Ликвидированое\n            "),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "afil-legend-edge afil-legend-edge__upr" },
      [_c("div", { staticClass: "afil-legend-edge__text" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "afil-legend-edge afil-legend-edge__lupr" },
      [_c("div", { staticClass: "afil-legend-edge__text" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "afil-legend-edge afil-legend-edge__uchr" },
      [_c("div", { staticClass: "afil-legend-edge__text" }, [_vm._v("100%")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "afil-legend-edge afil-legend-edge__luchr" },
      [_c("div", { staticClass: "afil-legend-edge__text" }, [_vm._v("Учр.")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "afil-legend-edge afil-legend-edge__reestr" },
      [
        _c("div", { staticClass: "afil-legend-edge__text" }, [
          _vm._v("Реестродерж."),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "afil-legend-edge afil-legend-edge__predsh" },
      [_c("div", { staticClass: "afil-legend-edge__text" }, [_vm._v("Предш")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "afil-legend-edge afil-legend-edge__preem" },
      [_c("div", { staticClass: "afil-legend-edge__text" }, [_vm._v("Преем.")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "afil-legend-edge afil-legend-edge__rodstv" },
      [
        _c("div", { staticClass: "afil-legend-edge__text" }, [
          _vm._v("Родств."),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "afil-legend-edge afil-legend-edge__staff" },
      [
        _c("div", { staticClass: "afil-legend-edge__text" }, [
          _vm._v("Сотруд."),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }